<template>
  <div class="ExternalApp">
    <div
      v-for="(item, index) in appData"
      :key="index"
      class="mobile_app"
      :class="[index % 2 == 0 ? 'App_content_even' : 'App_content_odd']"
      :id="item.id"
    >
      <div class="text_">
        <span>{{ $t("App.ExternalApp") }}</span>
      </div>

      <div class="ExternalApp">
        <div class="App_img">
          <img :src="item.img" alt />
        </div>
        <div class="App_text">
          <div class="App_text_div">
            <p
              class="App_text_title enfamilytitle"
              :class="[language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle']"
            >
              {{ item.title }}
            </p>
            <div
              class="App_text_conten"
              :class="[language == 'zh' ? 'zhFamily' : 'enfamily']"
              v-html="item.content"
            ></div>
            <span class="App_more" @click="toOtherSystem(item.link)"
              >{{ $t("App.learnMore") }}></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="App">
    <div
      v-for="(item,index) in appData"
      :key="index"
      class="mobile_app"
      :style="{background:item.background}"
      :class="[index%2 ==0?'App_content_even':'App_content_odd']"
      :id="item.id"
    >
      <div class="back_right" :style="{background:item.background}">
        <div class="back_right_bg"></div>
      </div>
      <div class="App_img">
        <img :src="item.img" alt />
      </div>
      <div class="App_text">
        <p class="App_text_title">{{item.title}}</p>
        <div class="App_text_conten">{{item.content}}</div>
        <span class="App_more" @click="toOtherSystem(item.link)">了解更多></span>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapMixin } from "@/util/mixin";
import util from "@/util/util.js";
import { Toast } from "mint-ui";
// const imageUrl = `${util.ImageUrl}`;
export default {
  mixins: [mapMixin],
  computed: {
    appData() {
      return [
        {
          id: "app4",
          title: this.$t("App.app5"),
          background: "rgba(34, 188, 288, 1)",
          link: `http://cloud.cropwatch.com.cn/`,
          img: require("@/assets/image/AppMarket/app8.png"),
          content: this.$t("App.app4"),
        },

        // {
        //   id: "app2",
        //   title:this.$t('App.app8'),
        //  background: "rgba(74, 159, 65, 1)",
        //   link: `http://59.110.45.31:8090/`,
        //   img: require("@/assets/image/AppMarket/app6.png"),
        //   content: this.$t("App.app2"),
        // },
      ];
    },
  },
  data() {
    return {
      pageIndex: 1, //判断是不是首页
      activeIndex: 1,
      NavBar: 1,
      // appData: [
      //   {
      //     id: "terraViewSDGs",
      //     title: "TerraView-SDGs",
      //     background: "rgba(34, 188, 288, 1)",
      //     link: `${util.baseUrl}/terraview-sdgs`,
      //     img: require("@/assets/image/AppMarket/app1.png"),
      //     content:
      //       "该应用通过收集、整理SDG相关数据，提供SDG指标全球尺度的可视化、SDG指标计算数据的浏览、SDG指标的对比分析以及可视化图表的定制与输出。"
      //   },
      //   {
      //     id: "terraViewSateye",
      //     title: "TerraView-SatEYE",
      //     background: "rgba(74, 159, 65, 1)",
      //     link: `${util.baseUrl}/terraview-sateye`,
      //     img: require("@/assets/image/AppMarket/app2.png"),
      //     content:
      //       "SatEYEs是一个在线地图工具，用于为政府、企业和公众提供海量空间数据的便捷访问方式，促进数据的开放和共享。"
      //   },
      //   {
      //     id: "terraViewFire",
      //     title: "TerraView-Fire",
      //     background: "rgba(248, 158, 46, 1)",
      //     link: `${util.baseUrl}/terraview-fire`,
      //     img: require("@/assets/image/AppMarket/app3.png"),
      //     content:
      //       "森林火灾会对人、财产和野生动物造成危险，对森林的健康至关重要，TerraView-Fire利用遥感卫星探测全球范围内的火点并提供历史火灾数据以及火灾事件的统计分析。"
      //   },
      //   {
      //     id: "terraViewCovidTracker",
      //     title: "TerraView-COVIDTracker",
      //     background: "rgba(221, 119, 103, 1)",
      //     link: `${util.baseUrl}/terraview-covidtracker`,
      //     img: require("@/assets/image/AppMarket/app4.png"),
      //     content:
      //       "该应用通过收集、整理COVID-19相关数据，提供了一个从多维度了解全球疫情分布情况及变化趋势的可视化窗口，并实现报表的定制和输出。"
      //   }
      // ]
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        if (
          to.path == "/sdgsindicators" ||
          to.path == "/login" ||
          to.path == "/register" ||
          to.path == "/forget"
        ) {
          this.show = false;
        } else {
          this.show = true;
        }
        if (
          to.path == "/" ||
          to.path == "/datahub" ||
          to.path == "/sdgsindicators" ||
          to.path == "/appMaket2"
        ) {
          this.pageIndex = 1;
          this.NavBar = 1; //判断是不是首页
          this.headWhite = false;
        } else {
          this.headWhite = true;
          this.pageIndex = 2;
          this.NavBar = 2;
        }
      },

      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    toOtherSystem(index) {
      if (document.body.clientWidth < 860) {
        Toast({
          message: this.$t("App.NoMobile"),
          position: "center",
          duration: 2000,
        });
      } else {
        window.open(index, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .zhFamilytitle {
    font-family: $zhFamily;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
  }
  .zhFamily {
    font-family: $zhFamily;
  }
  .enfamily {
    font-family: $enFamily;
  }
  .ExternalApp {
    margin-top: 10px;
    width: 100%;
    position: relative;

    .App_content_even {
      padding-top: 30px;
      width: 1200px;
      margin: auto;
      //   display: flex;
      //   flex-direction: row-reverse;
      .ExternalApp {
        width: 100%;
        display: flex;
        flex-direction: row;
      }
        .text_ {
        text-align: center;
        // display: inline-block;
        color: #333;
        font-size: 48px;
        line-height: 1.478;
        span {
          position: relative;
          display: inline-block;
          margin-bottom: 15px;
          &:after {
            content: "";
            height: 2px;
            position: absolute;
            left: 0;
            background-color: #c7000b;
            width: 100%;
            display: inline-block;
            bottom: -14px;
          }
        }
      }
      .back_right {
        position: absolute;
        width: 50%;
        left: 0;
        background: rgba(34, 188, 288, 1);
        height: 450px;
        z-index: -1;
        .back_right_bg {
          width: 100%;
          height: 100%;
          background: url("../../../assets/image/AppMarket/bg.png") no-repeat;
          z-index: 69;
          background-size: 100% 100%;
        }
      }
      .App_img {
        padding-top: 30px;
        z-index: 1;
        width: 700px;
        height: 500px;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .App_text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: -60px;
        z-index: 111;

        margin-top: -60px;

        color: #333;
        .App_text_div {
          box-shadow: 2px 2px 8px #c4c4c4;
          padding: 40px 40px;
          border-radius: 5px;
          background: #fff;
          .App_text_title {
            font-size: 26px;
            line-height: 26px;
            font-weight: 600;
            //   color: #fff;
          }
          .App_text_conten {
            margin-top: 20px;
            margin-bottom: 20px;
            //   color: #fff;
            font-size: 14px;
            line-height: 24px;
          }
          .App_more {
            cursor: pointer;
            margin-top: 30px;
            padding: 10px 20px;
            background: #f3f3f3;
            color: #2e5685;
            // display: inline-block;
            width: fit-content;
            font-size: 14px;
            border-radius: 20px;
          }
          .App_more:hover {
            transition: 0.2s;
            color: #333;
            background: #fff;
            box-shadow: 0px 2px 4px #fff;
          }
        }
      }
    }
    .App_content_odd {
      padding-top: 30px;
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: row;

      .back_right {
        position: absolute;
        width: 50%;
        right: 0;
        // background: rgba(34, 188, 288, 1);
        height: 450px;
        z-index: -1;
        .back_right_bg {
          width: 100%;
          height: 100%;
          background: url("../../../assets/image/AppMarket/bg.png") no-repeat;
          z-index: 69;
          background-size: 100% 100%;
        }
      }
      .App_img {
        padding-top: 30px;
        z-index: 1;
        width: 700px;
        height: 500px;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .App_text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: -10px;
        .App_text_title {
          font-size: 26px;
          line-height: 26px;
          font-weight: 600;
          color: #fff;
        }
        .App_text_conten {
          margin-top: 20px;
          color: #fff;
          font-size: 14px;

          line-height: 24px;
        }
        .App_more {
          cursor: pointer;
          margin-top: 30px;
          padding: 10px 20px;
          background: #f8f8f8;
          color: #2e5685;
          // display: inline-block;
          width: fit-content;
          font-size: 14px;
          border-radius: 20px;
        }
        .App_more:hover {
          transition: 0.2s;
          color: #333;
          background: #fff;
          box-shadow: 0px 2px 4px #fff;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .ExternalApp {
    margin-top: 60px;
    width: 100%;
    position: relative;

    .App_content_even {
      padding-top: 30px;
      width: 1200px;
      margin: auto;
      //   display: flex;
      //   flex-direction: row-reverse;
      .ExternalApp {
        width: 100%;
        display: flex;
        flex-direction: row;
      }
        .text_ {
        text-align: center;
        // display: inline-block;
        color: #333;
        font-size: 48px;
        line-height: 1.478;
        span {
          position: relative;
          display: inline-block;
          margin-bottom: 15px;
          &:after {
            content: "";
            height: 2px;
            position: absolute;
            left: 0;
            background-color: #c7000b;
            width: 100%;
            display: inline-block;
            bottom: -14px;
          }
        }
      }

      .back_right {
        position: absolute;
        width: 50%;
        left: 0;
        background: rgba(34, 188, 288, 1);
        height: 450px;
        z-index: -1;
        .back_right_bg {
          width: 100%;
          height: 100%;
          background: url("../../../assets/image/AppMarket/bg.png") no-repeat;
          z-index: 69;
          background-size: 100% 100%;
        }
      }
      .App_img {
        padding-top: 30px;
        z-index: 1;
        width: 700px;
        height: 500px;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .App_text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: -100px;
        z-index: 111;

        margin-top: -60px;

        color: #333;
        .App_text_div {
          box-shadow: 2px 2px 8px #c4c4c4;
          padding: 40px 40px;
          border-radius: 5px;
          background: #fff;
          .App_text_title {
            font-size: 26px;
            line-height: 26px;
            font-weight: 600;
            //   color: #fff;
          }
          .App_text_conten {
            margin-top: 20px;
            margin-bottom: 20px;
            //   color: #fff;
            font-size: 14px;
            line-height: 24px;
          }
          .App_more {
            cursor: pointer;
            margin-top: 30px;
            padding: 10px 20px;
            background: #f3f3f3;
            color: #2e5685;
            // display: inline-block;
            width: fit-content;
            font-size: 14px;
            border-radius: 20px;
          }
          .App_more:hover {
            transition: 0.2s;
            color: #333;
            background: #fff;
            box-shadow: 0px 2px 4px #fff;
          }
        }
      }
    }
    .App_content_odd {
      padding-top: 30px;
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: row;

      .back_right {
        position: absolute;
        width: 50%;
        right: 0;
        // background: rgba(34, 188, 288, 1);
        height: 400px;
        z-index: -1;
        .back_right_bg {
          width: 100%;
          height: 100%;
          background: url("../../../assets/image/AppMarket/bg.png") no-repeat;
          z-index: 69;
          background-size: 100% 100%;
        }
      }
      .App_img {
        padding-top: 30px;
        z-index: 1;
        width: 700px;
        height: 500px;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .App_text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: -100px;
        .App_text_title {
          font-size: 30px;
          font-weight: 600;
          color: #fff;
        }
        .App_text_conten {
          margin-top: 20px;
          color: #fff;
          font-size: 14px;
          line-height: 24px;
        }
        .App_more {
          cursor: pointer;
          margin-top: 30px;
          padding: 10px 20px;
          background: #f8f8f8;
          color: rgba(0, 84, 255, 1);
          // display: inline-block;
          width: fit-content;
          border-radius: 20px;
        }
        .App_more:hover {
          transition: 0.2s;
          color: #333;
          background: #fff;
          box-shadow: 0px 2px 4px #fff;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .ExternalApp {
    width: 100%;
    position: relative;
    .mobile_app {
      // padding-top: 30px;
      padding-bottom: 20px;
      // margin-bottom: 10px;
      width: 100%;
      margin: 4px auto;
      display: flex;
      flex-direction: column;
      position: relative;
      .back_right {
        position: absolute;
        width: 100%;
        // left: 0;
        height: 100%;
        // background: rgba(34, 188, 288, 1);
        // height: 400px;
        // z-index: -1;
        .back_right_bg {
          width: 100%;
          height: 100%;
          background: url("../../../assets/image/AppMarket/bg.png") no-repeat;
          // z-index: 69;
          opacity: 0.4;
          background-size: cover;
        }
      }
       .text_ {
        text-align: center;
        // display: inline-block;
        color: #333;
        font-size: 48px;
        line-height: 1.478;
        span {
          position: relative;
          display: inline-block;
          margin-bottom: 15px;
          &:after {
            content: "";
            height: 2px;
            position: absolute;
            left: 0;
            background-color: #c7000b;
            width: 100%;
            display: inline-block;
            bottom: -14px;
          }
        }
      }
      .App_img {
        // padding-top: 30px;
        z-index: 1;
        padding: 30px 10px 10px;
        // height: 500px;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .App_text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // margin-top: -100px;
        padding: 10px 20px;
        z-index: 999;
        .App_text_title {
          font-size: 30px;
          font-weight: 600;
          color: #333;
        }
        .App_text_conten {
          margin-top: 20px;
          color: #333;
          font-size: 16px;
          margin-bottom: 20px;
        }
        .App_more {
          text-align: center;
          cursor: pointer;
          margin-top: 60px;
          font-size: 14px;
          padding: 10px 20px;
          z-index: 99;
          background: #f8f8f8;
          color: rgba(0, 84, 255, 1);
          // display: inline-block;
          width: fit-content;
          border-radius: 20px;
        }
        .App_more:hover {
          transition: 0.2s;
          color: #333;
          background: #fff;
          box-shadow: 0px 2px 4px #fff;
        }
      }
    }
  }
}
</style>